import { Add } from '@mui/icons-material';
import { Box, Button, Stack, Typography } from '@mui/material';
import EmptyThumbSvg from '../../utility/Svg/EmptyThumbSvg';

// ── Styles ─────────────────────────────────────────────────────────────────
const styles = {
    wrapper: {
        px: { xs: 2, sm: 4 },
        py: { xs: 6, sm: 8 },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        // Make the empty state comfortably fit/center across screen sizes
        minHeight: {
            xs: 'calc(100dvh - 380px)',
            sm: 'calc(100dvh - 420px)',
        },
    },
    title: {
        fontSize: '48px',
        fontWeight: 700,
        mt: '20px',
        lineHeight: '116.7%',
    },
    subtitle: {
        fontSize: '20px',
        fontWeight: 400,
        letterSpacing: '0.17px',
        lineHeight: '143%',
        textAlign: 'center',
        maxWidth: 380,
        mt: '8px !important',
    },
};

const ReviewRequestEmptyState = ({ onSendFirstRequest }) => {
    return (
        <Box sx={styles.wrapper}>
            <Stack alignItems="center" spacing={0}>
                <EmptyThumbSvg />
                <Typography variant="h5" fontWeight={700} sx={styles.title}>
                    Start Here
                </Typography>
                <Typography variant="body1" sx={styles.subtitle}>
                    Boost your Google Rating in 10 seconds.
                </Typography>
                <Button
                    variant="outlined"
                    color="secondary"
                    startIcon={<Add />}
                    onClick={onSendFirstRequest}
                    sx={{ mt: '30px', textTransform: 'uppercase', letterSpacing: '0.5px' }}
                >
                    SEND YOUR FIRST REQUEST
                </Button>
            </Stack>
        </Box>
    );
};

export default ReviewRequestEmptyState;
